import styled from 'styled-components';

export const ComposeContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 96px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px -1px 0px 0px #d1d1d1;
`;

export const ComposeContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 3px;
  width: 760px;

  @media (max-width: 1024px) {
    width: 90%;
  }

  @media (max-width: 768px) {
    width: 95%;
  }

  @media (max-width: 480px) {
    width: calc(100% - 24px);
  }
`;

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
  background: #ffffff;
  border-radius: 3px 3px 2px 2px;
  box-shadow:
    0px 0px 2px 0px rgba(0, 0, 0, 0.12),
    0px 1px 2px 0px rgba(0, 0, 0, 0.14);
  height: 44px;
  display: flex;
  align-items: center;
  padding: 0 16px;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: #5b5fc7;
    border-radius: 0 0 3px 3px;
  }

  @media (max-width: 480px) {
    padding: 0 12px;
    height: 40px;
  }
`;

export const Input = styled.input`
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-family: 'Segoe UI', sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #242424;

  &::placeholder {
    color: #424242;
  }

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 32px;
  position: relative;
`;

export const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 0;

  @media (max-width: 480px) {
    gap: 0;
    
    /* Hide some buttons on very small screens */
    button:nth-child(4), /* GIF */
    button:nth-child(5), /* Sticker */
    button:nth-child(6)  /* Schedule */
    {
      display: none;
    }
  }
`;

export const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 6px;
  background: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  color: #424242;

  &:hover {
    background: #f4f4f4;
  }

  @media (max-width: 480px) {
    width: 28px;
    height: 28px;
    padding: 4px;
  }
`;

export const SendButton = styled(IconButton)`
  margin-left: auto;
`;

export const Icon = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
    display: block;
  }
`;

